import React from "react";
import { connect } from "react-redux";
import Header from "./Header";
import { getSessionDetails, loadActivities } from "../actions";
import Banner from "./Banner";
import LandingPage from "./LandingPage";

class App extends React.Component {
  componentDidMount() {
    setTimeout(() => this.props.getStatus(), 1500);
    const data = JSON.parse(window.__FIRSTLOAD);
    const activities = data.activities;
    const count = data.count;
    this.props.loadActivities(activities, count);
  }
  render() {
    return (
      <div className="t-container-fluid">
        <Header />
        <Banner />
        <LandingPage />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    destinations: state.destinations,
    currency: state.currency,
    cart: state.cart
  };
};

const mapDistpatchToProps = dispatch => {
  return {
    getStatus: () => dispatch(getSessionDetails()),
    loadActivities: (activities, count) => dispatch(loadActivities(activities, count))
  };
};
export default connect(
  mapStateToProps,
  mapDistpatchToProps
)(App);
